let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8jh2d")).then(() => parcelRequire('hv4be'));